import { Download, ExternalLink } from "lucide-react";

export default function ImageCard({ imageUrl, title, prompt }) {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = `pearmedia-${Date.now()}.png`;
    link.target = "_blank";
    link.click();
  };

  return (
    <div className="image-card">
      <div className="image-card-header">
        <span className="image-card-title">{title || "Generated Image"}</span>
        <div className="image-card-actions">
          <button className="icon-btn" onClick={handleDownload} title="Download">
            <Download size={16} />
          </button>
          <a
            className="icon-btn"
            href={imageUrl}
            target="_blank"
            rel="noreferrer"
            title="Open Full Size"
          >
            <ExternalLink size={16} />
          </a>
        </div>
      </div>

      <div className="image-card-img-wrapper">
        <img src={imageUrl} alt={title || "AI Generated"} className="image-card-img" />
      </div>

      {prompt && (
        <div className="image-card-prompt">
          <span className="prompt-label">Prompt used:</span>
          <p className="prompt-text">{prompt}</p>
        </div>
      )}
    </div>
  );
}
